import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { parseJSON } from 'jquery';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    let headerGaurd:any=null;
    // Add or modify headers here
    if(localStorage.getItem('userData')!=null){
      let userData=parseJSON(localStorage.getItem('userData')+"");
      console.log(localStorage.getItem('userData'),'checkLogin',userData.authToken);
      headerGaurd = request.clone({
        setHeaders: {
          'Authorization':'Bearer '+userData.authToken,
          'id':userData.id+""
        },
      });

    // Pass the modified request to the next interceptor or handler
    return next.handle(headerGaurd);
    }else{
      headerGaurd = request.clone({
        setHeaders: {},
      });
      return next.handle(headerGaurd);

    }
    
    // Add or modify headers here
   

  }
}
